module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.notices), function(notice) {
    return _c('Notice', {
      key: notice.name,
      attrs: {
        "content": notice.content,
        "duration": notice.duration,
        "name": notice.name,
        "transition-name": notice.transitionName,
        "on-close": notice.onClose
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c4ca2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/notification.vue
// module id = 462
// module chunks = 9